export default {
  data() {
    return {
      rowObserver: null,
      headerObserver: null,
      isTabPressed: false,
      isShiftTabPressed: false,
      isTickerFocused: false
    };
  },
  methods: {
    setHeaderRowObservers() {
      /* TBD: remove/refactor when supported by ag-grid/JAWS. see below.
       * Ag-grid places aria-sort='none' attribute into unsorted / sortable columns. As aria-sort tag behaviour is not completely
       *  documented in the standards, JAWS processes the tags incorrectly. The following code observes changes in the headers,
       *  and adds aria-label attrute to the gridcell div for unsorted columns. See TDWATP-6230 for further comments and
       *  links to JAWS / WCAG standards discussion.
       */
      this.$el.querySelectorAll(`.ag-header-row`).forEach(headerRow => {
        this.headerRowObserver.observe(headerRow, {
          childList: true,
          attributes: false,
          characterData: false,
          subtree: false
        });

        headerRow.addEventListener('focusin', this.onFocusIn);
        headerRow.addEventListener('focusout', this.onFocusOut);
      });

      // setting attributes/observers for the headers that were added to DOM before row observer was added.
      const headerElements = this.$el.querySelectorAll(`.ag-header-row .ag-header-cell-sortable`);
      this.setHeaderCellObservers(headerElements);
    },
    setHeaderCellObservers(headers) {
      headers.forEach(headerElement => {
        if (headerElement.classList.contains('ag-header-cell-sortable')) {
          const eText = headerElement.querySelector('.ag-header-cell-text');
          const label = `${eText ? eText.innerText : ''}. ${this.$t('white-label.globalLabels.sortable')}`;
          headerElement.setAttribute('mm5-label', label);

          this.headerCellObserver.observe(headerElement, {
            attributes: true,
            attributeFilter: ['aria-sort'],
            childList: false,
            characterData: false,
            subtree: false
          });
        }
      });
    },
    onCellFocused(params, baseElement) {
      const parentElement = baseElement || this.$el;

      const column = params.column;
      if (!column) return;

      const node = column.gridApi.getDisplayedRowAtIndex(params.rowIndex);
      const nodeData = node.data;

      let shift = 0;
      if (nodeData) {
        // shifting row for mlo column types.
        if (
          column.colDef.type &&
          column.colDef.type.includes('mlo') &&
          nodeData &&
          ((this.inlineEditing && nodeData.modifyRendererFlag) || nodeData.allSameStatus)
        )
          if (column.colId !== 'ticker') {
            shift = nodeData.index ? -nodeData.index : 0;
          }
      }

      let actionElement = null;
      let cellElement = parentElement.querySelector(
        `[row-index="${node.rowIndex + shift}"] > div[col-id="${column.colId}"]`
      );

      if (cellElement) {
        if (this.inlineEditing && this.inlineEditingColumns && this.inlineEditingColumns.includes(column.colId)) {
          if (cellElement.classList.contains('editable')) {
            this.isTabPressed = false;
            this.isShiftTabPressed = false;
            return;
          }
        } else if (column.colId === 'q._TCR' || column.colId === 'ticker') {
          if (this.orderDetails) {
            if (this.isTickerFocused || !['EQUITY', 'OPTION'].includes(nodeData.security.type)) {
              actionElement = cellElement.querySelector('.ticker-button');
            } else {
              actionElement = cellElement.querySelector('.order-details-collapse');
              for (let i = 1; i < 3; i++) {
                if (!actionElement) {
                  actionElement = cellElement
                    .closest('.widget-body')
                    .querySelector(`div[row-index="${params.rowIndex + i}"] .order-details-collapse`);
                } else break;
              }
            }
          } else {
            actionElement = cellElement.querySelector('.ticker-button');
          }
        } else {
          actionElement = cellElement.querySelector(
            'div:not(.ag-hidden) button:enabled, div:not(.ag-hidden) input:enabled, .c-js-tick-flash.buy, .c-js-tick-flash.sell'
          );
        }
        if (actionElement) {
          actionElement.focus();
          this.isTabPressed = false;
          this.isShiftTabPressed = false;
          return;
        }
      }

      if (this.isShiftTabPressed) {
        column.gridApi.tabToPreviousCell();
      } else if (this.isTabPressed) {
        column.gridApi.tabToNextCell();
      } else {
        this.isTabPressed = false;
        this.isShiftTabPressed = false;
      }
    },
    tabToNextHeader(params) {
      let nextHeader = params.nextHeaderPosition;

      if (nextHeader && !nextHeader.column.colDef.sortable) {
        let rowIndex = nextHeader.headerRowIndex;

        const columns = nextHeader.column.columnApi.getAllDisplayedColumns();
        let columnIndex = columns.findIndex(column => column.colId === nextHeader.column.colId);

        while (rowIndex >= 0 && rowIndex < params.headerRowCount) {
          while (columnIndex >= 0 && columnIndex < columns.length - 1) {
            columnIndex += params.backwards ? -1 : 1;
            nextHeader.column = columns[columnIndex];
            if (nextHeader.column && nextHeader.column.colDef.sortable) return nextHeader;
          }
          if (params.backwards) rowIndex--;
          else rowIndex++;
        }

        if (params.backwards) nextHeader = null;
        else {
          nextHeader.column = columns[0];
          nextHeader.headerRowIndex = -1;
        }
      }
      return nextHeader;
    },
    tabToNextCell(params, baseElement) {
      const parentElement = baseElement || this.$el;

      let nextCell = params.nextCellPosition;
      if (nextCell) {
        const previousCell = params.previousCellPosition;

        if (this.inlineEditing) params.api.stopEditing();

        if (previousCell.column.colDef.type && previousCell.column.colDef.type.includes('mlo')) {
          const focusedCell = previousCell.column.gridApi.getFocusedCell();
          if (focusedCell.rowIndex != previousCell.rowIndex) {
            if (nextCell.rowIndex === previousCell.rowIndex) nextCell.rowIndex = focusedCell.rowIndex;
            else if (params.backwards) nextCell.rowIndex = focusedCell.rowIndex - 1;
          }
        }

        const columns = nextCell.column.columnApi.getAllDisplayedColumns();
        let columnIndex = columns.findIndex(column => column.colId === nextCell.column.colId);

        // the assumption here is that
        // 1. all rows have at least one actionable column and
        // 2. grid always renders rows neighbouring the current one.
        while (parentElement.querySelector(`.ag-row[row-index="${nextCell.rowIndex}"]`)) {
          while (columnIndex >= 0 && columnIndex < columns.length) {
            nextCell.column = columns[columnIndex];

            if (nextCell.column.colDef.type && nextCell.column.colDef.type.includes('actionable')) {
              if (!(this.inlineEditingColumns && this.inlineEditingColumns.includes(nextCell.column.colId))) {
                return nextCell;
              }
              if (this.inlineEditing) return nextCell;
            }
            columnIndex += params.backwards ? -1 : 1;
          }
          nextCell.rowIndex += params.backwards ? -1 : 1;
          columnIndex = params.backwards ? columns.length - 1 : 0;
        }

        if (params.backwards) {
          nextCell.rowIndex = -1;
          nextCell.column = columns[columns.length - 1];
        } else nextCell = null;
      }
      return nextCell;
    },
    onTabIntoFirstHeader(event) {
      if (this.isTabPressed && !this.isShiftTabPressed) {
        // tabbing into the first cell of the header
        if (
          !event.shiftKey &&
          event.target.getAttribute('aria-colindex') === '1' &&
          !event.target.classList.contains('ag-header-cell-sortable')
        ) {
          let gridOptions = this.gridOptions;
          if (this.tableState) {
            const section = event.target.closest('section').classList.item(0);
            gridOptions = this.tableState[section].gridOptions;
          }

          const columns = gridOptions.columnApi.getAllDisplayedColumns();
          let column = columns.find(column => column.colDef.sortable);
          if (column) {
            const columnElement = this.$el.querySelector(`.ag-header-cell[col-id="${column.colId}"]`);
            if (columnElement) columnElement.focus();
          } else {
            column = columns.find(column => column.colDef.type && column.colDef.type.includes('actionable'));
            if (column) gridOptions.api.setFocusedCell(0, column);
            else gridOptions.api.setFocusedCell(0, column[0]);
          }
        }
      }
    },
    onKeyDown(event) {
      if (event.target) {
        if (event.key === 'Tab') {
          this.isTabPressed = true;
          if (event.shiftKey) this.isShiftTabPressed = true;
        } else {
          this.isTabPressed = false;
          this.isShiftTabPressed = false;
        }
      }
    },
    onClick(event) {
      this.isTabPressed = false;
      this.isShiftTabPressed = false;
      if (!event.target.classList.contains('ticker-button')) {
        this.isTickerFocused = false;
      }
    },
    setIsTickerFocused(val, checkFocusedStatus = false) {
      return (this.isTickerFocused = val || (checkFocusedStatus && this.isTickerFocused));
    },
    onFocusIn(event) {
      if (event.target.classList.contains('ag-header-cell-sortable'))
        event.target.setAttribute('aria-label', event.target.getAttribute('mm5-label'));

      if (event.target.getAttribute('aria-colindex') === '1') this.onTabIntoFirstHeader(event);
    },
    onFocusOut() {
      this.$el
        .querySelectorAll('.ag-header-row .ag-header-cell-sortable')
        .forEach(headerElement => headerElement.removeAttribute('aria-label'));
    }
  },
  mounted() {
    // TBD for the row/cell header observers - see comment in setRowObserver method
    // monitoring aria-sort and class changes in the header
    this.headerCellObserver = new MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.target.getAttribute('aria-sort') === 'none') {
          mutation.target.removeAttribute('aria-sort');
          mutation.target.setAttribute('aria-label', mutation.target.getAttribute('mm5-label'));
        } else if (mutation.target.hasAttribute('aria-sort')) mutation.target.removeAttribute('aria-label');
      });
    });

    this.headerRowObserver = new MutationObserver(mutationList => {
      mutationList.forEach(mutation => {
        if (mutation.type === 'childList') this.setHeaderCellObservers(mutation.addedNodes);
      });
    });

    // monitoring keydown event to manage focus in the headers/cells
    // on tab keydown in the element, set tab-pressed flags
    // on any other keydown, drop tab-pressed flags
    this.$el.addEventListener('keydown', this.onKeyDown);

    // on click, drop tab-pressed flags
    this.$el.addEventListener('click', this.onClick);
  },
  beforeDestroy() {
    this.$el.removeEventListener('keydown', this.onKeyDown);
    this.$el.removeEventListener('click', this.onClick);

    this.$el.querySelectorAll(`.ag-header-row`).forEach(headerRow => {
      headerRow.removeEventListener('focusin', this.onFocusIn);
      headerRow.removeEventListener('focusout', this.onFocusOut);
    });
    this.$el = null;
  }
};
